import { combineReducers } from "redux";
import {
  KRIMonitoringCommand,
  KRIMonitoringDefault,
  KRIMonitoringReducer,
} from "./kri-monitoring/reducer";
import {
  KRIRegisterCommand,
  KRIRegisterDefault,
  KRIRegisterReducer,
} from "./kri/reducer";
import { KRIModel } from "./types";
import {
  PemantauanKRIRegisterCommand,
  PemantauanKRIRegisterDefault,
  PemantauanKRIRegisterReducer,
} from "./pemantauan-kri/reducer";

const KRIReducer = combineReducers({
  kriMonitoring: KRIMonitoringReducer,
  kri: KRIRegisterReducer,
  pemantauan: PemantauanKRIRegisterReducer
});

const KRIDefault: KRIModel = {
  kriMonitoring: KRIMonitoringDefault,
  kri: KRIRegisterDefault,
  pemantauan: PemantauanKRIRegisterDefault,
};

const KRICommand = {
  kriMonitoring: KRIMonitoringCommand,
  kri: KRIRegisterCommand,
  pemantauan: PemantauanKRIRegisterCommand,
};

export { KRIReducer, KRIDefault, KRICommand };
